import { FlagDE, FlagDK, FlagFI, FlagNO, FlagPL, FlagSE, FlagUK, FlagES } from '@comeon/vectors';
import styled from 'styled-components';

const FLAGS = {
	en: <FlagUK />,
	sv: <FlagSE />,
	no: <FlagNO />,
	fi: <FlagFI />,
	da: <FlagDK />,
	de: <FlagDE />,
	pl: <FlagPL />,
	es: <FlagES />
};

const Flag = styled.div`
	svg {
		border-radius: 50%;
		height: 16px;
		width: 16px;
	}
`;

const WeSpinFlag = ({ language }) => {
	if (language === null) {
		return null;
	}

	return <Flag>{FLAGS[language]}</Flag>;
};

export default WeSpinFlag;
